import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Charge les traductions depuis des fichiers distants
  .use(LanguageDetector) // Détecte automatiquement la langue de l'utilisateur
  .use(initReactI18next) // Initialise i18next avec React
  .init({
    lng: 'en',
    fallbackLng: 'en', // Langue par défaut si la détection échoue
    debug: true,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false, // Non nécessaire pour React
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Chemin des fichiers de traduction
    },
  });

export default i18n;
